

import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import { TranslationHandler } from '../mixins/TranslationHandler'
import { Getter } from 'vuex-class'

@Component({})
export default class AssetServiceLogin extends Mixins(TranslationHandler) {
  @Prop() service!: string
  @Getter visualPrimaryColor!: string
}
